import React from 'react'
import { Link } from 'react-router-dom'
import SEO from '../components/SEO'

export default function NotFoundPage() {
  return (
    <>
      <SEO
        title="404 – Siden blev ikke fundet – Krüger Wet Blaster ApS"
        description="Den side du leder efter findes desværre ikke."
      />

      <div className="min-h-[70vh] flex items-center justify-center py-20 px-4 sm:px-6 lg:px-8 bg-slate-50">
        <div className="max-w-md w-full text-center space-y-6 bg-white p-8 sm:p-10 rounded-2xl border border-slate-200/90 shadow-sm">
          <div className="w-16 h-16 rounded-2xl bg-sky-50 border border-sky-200 text-sky-600 flex items-center justify-center mx-auto text-2xl font-mono font-bold">
            404
          </div>

          <div className="space-y-2">
            <h1 className="text-2xl font-extrabold text-slate-900 tracking-tight">
              Siden blev ikke fundet
            </h1>
            <p className="text-sm text-slate-600 leading-relaxed">
              Vi beklager, men siden du leder efter findes ikke, er blevet flyttet eller har skiftet adresse.
            </p>
          </div>

          <div className="pt-2 flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-sky-600 hover:bg-sky-500 text-white font-semibold text-sm px-5 py-2.5 rounded-lg shadow-sm transition-colors"
            >
              <i className="fa-solid fa-house text-xs" aria-hidden="true" />
              <span>Gå til forsiden</span>
            </Link>

            <Link
              to="/produkter"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-slate-100 hover:bg-slate-200 text-slate-800 font-medium text-sm px-5 py-2.5 rounded-lg transition-colors"
            >
              <i className="fa-solid fa-boxes-stacked text-xs" aria-hidden="true" />
              <span>Se produkter</span>
            </Link>
          </div>
        </div>
      </div>
    </>
  )
}
